import propTypes from "prop-types";

const ButtonWithIcon = ({
  onClick = null,
  id=null,
  type = "button",
  title = "title",
  src = "",
  disabled=false,
}) => {
  return (
    <button
      type={type}
      id={id}
      onClick={onClick}
      className="btn btn-primary btn-login bg-l"
      disabled={disabled}
    >
      {title}&emsp;
      <img className="g-icon-alinment" src={src} alt="" />
    </button>
  );
};

ButtonWithIcon.propTypes = {
  onClick: propTypes.func,
  type: propTypes.string,
  id: propTypes.string,
  title: propTypes.string.isRequired,
  src: propTypes.oneOfType([propTypes.object, propTypes.string]),
};

export default ButtonWithIcon;
